import { resolveMutationErrorMessage } from "@/shared/api/error-message";
import { resolveCommunicationErrorKey } from "./error-codes";

/**
 * Communications-domain wrapper around the shared mutation error resolver.
 * Recognised structured `errorCode`s render the curated
 * `communications.errors.*` copy; everything else falls through to the
 * generic 401/403/4xx/5xx ladder (mirrors `resolveComplianceError`).
 */
export function resolveCommunicationError(
  err: unknown,
  t: (key: string, values?: Record<string, unknown>) => string,
): string {
  const known = resolveCommunicationErrorKey(err);
  if (known) {
    return t(known.i18nKey);
  }
  return resolveMutationErrorMessage(err, t, {
    forbiddenKey: "communications.errors.forbidden",
    serverPrefixKey: "communications.errors.serverPrefix",
    genericKey: "communications.errors.generic",
  });
}
